import {
  CreateReservationMutation,
  CreateReservationMutationVariables,
} from '@data/__generated__/types.reservations'
import getErrorMessage from '@helpers/misc/getErrorMessage'
import sleep from '@helpers/misc/sleep'
import {clientNames} from '@providers/services'
import {gql, useMutate} from 'apollo-hooks'
import {useRouter} from 'next/router'

import {useCreateReservationContext} from '../../ReservationContext'

export function useCreateReservation({setErrorMessage}) {
  const mutate = useMutate()
  const context = useCreateReservationContext()
  const router = useRouter()
  return async () => {
    setErrorMessage('')
    try {
      const params: CreateReservationMutationVariables = {
        storeId: context.storeOptions._id,
        startsAt: context.date,
        partySize: context.partySize,
        sectorId: context.sectorId,
        specialRequests: context.specialRequests,
        specialOccasion: context.specialOccasion,
        isWaitingList: context.isWaitingList,
        source: 'web',
        clientData: {
          firstName: context.firstName,
          lastName: context.lastName,
          email: context.email,
          phone: context.phone,
        },
      }
      const {createReservation} = await mutate<
        CreateReservationMutation,
        CreateReservationMutationVariables
      >({
        clientName: clientNames.reservations,
        mutation: gql`
          mutation createReservation(
            $storeId: String
            $startsAt: Date
            $partySize: Float
            $sectorId: String
            $specialRequests: String
            $specialOccasion: String
            $isWaitingList: Boolean
            $clientData: ReservationClientDataInput
            $source: String
          ) {
            createReservation(
              startsAt: $startsAt
              partySize: $partySize
              sectorId: $sectorId
              clientData: $clientData
              specialRequests: $specialRequests
              specialOccasion: $specialOccasion
              isWaitingList: $isWaitingList
              storeId: $storeId
              source: $source
            ) {
              _id
              clientToken
            }
          }
        `,
        variables: params,
      })
      router.push(`/reserva/${createReservation.clientToken}`)
      await sleep(5000)
    } catch (error) {
      setErrorMessage(
        getErrorMessage(error, {
          'clientData.firstName': 'Nombre',
          'clientData.lastName': 'Apellido',
          'clientData.email': 'Email',
          'clientData.phone': 'Teléfono',
        }),
      )
    }
  }
}
